import type { Action } from '../action';

export enum EventTypeEnum {
  OnClick = 'onClick',
  OnSubmit = 'onSubmit',
  OnChange = 'onChange',
  OnOpen = 'onOpen',
  OnSave = 'onSave',
  OnRowSelect = 'onRowSelect',
  OnRowHover = 'onRowHover',
  OnClickCell = 'onClickCell',
  OnClose = 'onClose',
  OnCollapse = 'onCollapse',
  OnExpand = 'onExpand',
  OnOutputChange = 'onOutputChange',
  OnDataPointClick = 'onDataPointClick',
  OnFileUpload = 'onFileUpload',
  OnSuccess = 'onSuccess',
  OnFailure = 'onFailure',
  OnFocus = 'onFocus',
  OnBlur = 'onBlur',
  OnPhotoCapture = 'onPhotoCapture',
  OnRecordingStart = 'onRecordingStart',
  OnRecordingStop = 'onRecordingStop',
  OnRecordedFileCapture = 'onRecordedFileCapture',
  OnStepChange = 'onStepChange',
  OnMenuItemClick = 'OnMenuItemClick',
  OnReceiveNotification = 'onReceiveNotification',
  OnSendMessage = 'onSendMessage',
  OnCaseCreated = 'onCaseCreated',
  OnOrderChange = 'onOrderChange',
  OnTimerExpire = 'onTimerExpire',
  OnTimerIntervalElapsed = 'onTimerIntervalElapsed',
  OnMarkerClick = 'onMarkerClick',
  OnPermissionDenied = 'onPermissionDenied',
  OnCurrentTimeChange = 'onCurrentTimeChange',
  OnButtonClick = 'onButtonClick',
  OnSelectItem = 'onSelectItem',
  OnMessageSent = 'onMessageSent',
  OnCitationClick = 'onCitationClick',
  OnDeleteComment = 'onDeleteComment',
  OnPageLoad = 'onPageLoad',
  OnAddComment = 'onAddComment',
  OnAddReply = 'onAddReply',
  OnScan = 'onScan',
  OnFilterChange = 'onFilterChange',
  OnKeyboardShortcut = 'onKeyboardShortcut',
  OnPageChange = 'onPageChange',
  OnPress = 'onPress',
  OnLongPress = 'onLongPress',
  OnPullDown = 'onPullDown',
  OnCheckChange = 'onCheckChange',
  OnSwipeStart = 'onSwipeStart',
  OnSwipeEnd = 'onSwipeEnd',
  OnImageClick = 'onImageClick',
  OnMessageReceived = 'onMessageReceived',
  OnSelectInterval = 'onSelectInterval',
  OnSignatureCapture = 'onSignatureCapture',
  OnStartDictation = 'onStartDictation',
  OnEndDictation = 'onEndDictation',
}

export interface Event {
  /**
   * unique identifier for the event
   */
  id: string;
  /**
   * The event that triggers the action. This should correspond to a predefined set of events in the application.
   */
  eventType: string;

  action: Action;
  /**
   * The targetId by which the event will be triggered.
   * For example: In table where we have multiple UI elements for configuring actions for a single table block, we distinguish between them using targetId
   */
  targetId?: string;
  /**
   * Event is hidden and is not shown in the UI
   * For example: In Entity Form, Update Entity and Create Entity Events configuration are hidden from interactions Widget
   */
  hidden?: boolean;
  /**
   * Event type payload data
   */
  payload?: Record<string, unknown>;
}
